import React from 'react'

import { ReactComponent as ExitSvg } from '../../assets/ExitDelete.svg'
import SendGTAGEvent from '../../utils/sendGTAGEvent';

import { Container, ButtonOrder } from './styles'

interface IOrderModalItemProps {
    label: string;
    value: string;
    objtKey: string;
    onClickOrderButtonHandler: (key: string, value: string) => void;
    active: boolean;
}

const OrderModalItem: React.FC<IOrderModalItemProps> = ({
    label,
    value,
    onClickOrderButtonHandler,
    objtKey,
    active
}) => {


    return (
        <Container>
            <ButtonOrder active={active}
                onClick={() => {
                    onClickOrderButtonHandler(objtKey, value)
                    !active &&
                        SendGTAGEvent(
                            'seleciona_ordenacao',
                            'Ordenação',
                            'Clicou em botão "Ordenar"',
                            label
                        )

                }}>
                {label}
                {active && <ExitSvg />}
            </ButtonOrder>
        </Container>
    )
}

export default OrderModalItem